import type { CSSProperties, HTMLAttributes, MouseEvent } from "react";
import type { Bookmark } from "../types";
import { IconGlyph } from "./IconGlyph";

type BookmarkTileProps = {
  bookmark: Bookmark;
  onEdit: (bookmark: Bookmark) => void;
  dragHandlers?: HTMLAttributes<HTMLElement>;
  isReordering?: boolean;
  onInteractionClick?: (event: MouseEvent<HTMLElement>) => void;
};

const statusLabel = {
  online: "online",
  local: "LAN",
  protected: "Access",
  unknown: "check"
};

export function BookmarkTile({ bookmark, onEdit, dragHandlers, isReordering, onInteractionClick }: BookmarkTileProps) {
  return (
    <article
      className={`bookmark-tile ${isReordering ? "is-reordering" : ""}`}
      onClickCapture={onInteractionClick}
      onDragStart={(event) => event.preventDefault()}
      {...dragHandlers}
    >
      <a
        className="bookmark-launch"
        href={bookmark.url}
        target="_blank"
        rel="noreferrer"
        draggable={false}
        aria-label={`${bookmark.label} を開く`}
      >
        <span className="icon-shell" style={{ "--accent": bookmark.accent } as CSSProperties}>
          {bookmark.customIconDataUrl ? (
            <img className="custom-icon-image" src={bookmark.customIconDataUrl} alt="" draggable={false} />
          ) : (
            <IconGlyph name={bookmark.icon} />
          )}
        </span>
        <span className="bookmark-label">{bookmark.label}</span>
      </a>
      <button className="tile-edit" type="button" onClick={() => onEdit(bookmark)} aria-label={`${bookmark.label} を編集`}>
        Edit
      </button>
      <span className={`status-dot status-${bookmark.status ?? "unknown"}`}>{statusLabel[bookmark.status ?? "unknown"]}</span>
    </article>
  );
}
